module.exports = __webpack_public_path__ + "files/import-freezer-template.xlsx";